/* eslint-disable prettier/prettier */
import axios from "axios";
const sirepApiFiles = axios.create({
  // baseURL: "http://localhost:3012",
  // baseURL: "http://165.172.16.35:3012",
    baseURL :"https://api.mingobierno.gob.bo/siregpenapi"
});
sirepApiFiles.interceptors.request.use((config)=>{
  config.headers={
    "x-access-token":localStorage.getItem("token"),
  };
  return config
}

)
export default sirepApiFiles;
